var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "30", height: "30", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M23 6.875H7c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2zm-8.06 13.962l-.837-.762c-1.773-1.608-3.187-2.891-4.04-4.127h4.52a.3.3 0 0 0 .233-.112l.438-.544.578.75a.3.3 0 0 0 .53-.118l.452-1.978.443 3.47a.3.3 0 1 0 .583.057l.505-1.525h1.473c-.853 1.236-2.267 2.52-4.04 4.127l-.837.762zm5.253-5.495h-2.064a.3.3 0 0 0-.285.207l-.158.477-.49-3.834a.302.302 0 0 0-.283-.264.3.3 0 0 0-.308.234l-.687 3.004-.42-.547a.3.3 0 0 0-.471-.005l-.587.728H9.688c-.341-.632-.526-1.262-.526-1.93a3.144 3.144 0 0 1 3.178-3.178c1.006 0 1.97.468 2.6 1.202a3.475 3.475 0 0 1 2.6-1.202 3.144 3.144 0 0 1 3.179 3.178c0 .668-.185 1.298-.526 1.93z" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/icons/ConsultationIcon.svg